<template>
  <VisionLink
    :to="to"
    :class="classes"
    v-bind="$attrs"
  >
    <VisionIcon
      icon="arrow"
      :colour="iconTheme"
      :gradient="theme === 'gradient' ? gradientTheme : null"
      size="xx-small"
      :class="$b('icon')"
    />

    <BaseCopy
      tag="span"
      size="h5"
      :class="$b('text', { textTransform, size })"
    >
      <span>{{ text }}</span>
    </BaseCopy>
  </VisionLink>
</template>

<script>

export default {
  name: 'LinkDirectional',

  props: {
    to: {
      type: String,
      default: '/'
    },

    text: {
      type: String,
      required: true
    },

    size: {
      type: String,
      default: null,
      validator: (value) => {
        return [
          'small',
          'base'
        ].includes(value)
      }
    },

    textTransform: {
      type: String,
      default: null,
      validator: (value) => {
        return [
          'capitalize',
          'uppercase',
          'lowercase',
          'normal'
        ].includes(value)
      }
    },

    theme: {
      type: String,
      default: 'white',
      validator: (value) => {
        return [
          'white',
          'black',
          'gradient'
        ].includes(value)
      }
    }
  },

  computed: {
    classes () {
      return {
        LinkDirectional: true,
        [`LinkDirectional--${this.theme}`]: this.theme
      }
    },
    iconTheme () {
      return this.theme === 'gradient' ? 'black' : this.theme
    },
    gradientTheme () {
      return this.theme === 'gradient' ? 'default' : null
    }
  }
}
</script>

<style lang="postcss">
.LinkDirectional {
  @apply text-white
    opacity-90
    inline-flex
    items-center
    p-xxxs;

  transition: opacity .2s ease-in-out;

  @screen md {
    &:hover {
      @apply opacity-100;
    }
  }

  &:hover {
    color: theme('colors.white');
  }
}

.LinkDirectional__text {
  @apply uppercase t-align-fix
    leading-none
    flex
    items-center
    h-xxxs;

  margin-left: 10px;

  &--size-base {
    @apply text-sm md:text-base tracking-tight;
  }

  &--text-transform-capitalize {
    @apply capitalize;
  }

  &--text-transform-lowercase {
    @apply lowercase;
  }

  &--text-transform-normal {
    @apply normal-case;
  }
}

.LinkDirectional__icon {
  transition: transform .2s ease-in-out;
  transform: translate(0, 1px) rotate(180deg);

  .LinkDirectional:hover & {
    transform: translate(-4px, 1px) rotate(180deg);
  }
}

.LinkDirectional--black {
  @apply text-black;

  &:hover {
    background-position: 0;
    color: theme('colors.black');
  }
}

.LinkDirectional--gradient {
  .LinkDirectional__text {
    @apply text-black h-auto;
  }

  .LinkDirectional__icon {
    fill: theme('colors.off-black') !important;
  }

  &:hover {
    .LinkDirectional__text span {
      @apply t-gradient;
    }

    .LinkDirectional__icon {
      fill: var(--gradient-url) !important;
    }
  }
}
</style>
